export default "__VITE_ASSET__cfa7456b__"